<i18n src="@/locales/modules/NoteTranslate.json"></i18n>

<template>
	<div id="notes-management" class="data-list-container">
		<div class="flex flex-grow justify-end">
			<vs-input
				@focus="handleFocusSearch"
				ref="inputSearchRef"
				@input="handleSearch"
				size="large"
				class="input-search w-full lg:w-1/3"
				icon="search"
				:placeholder="$t('Actions.Search')"
				v-model="searchText"
			/>
		</div>

		<div class="flex flex-col-reverse lg:flex-row">
			<div class="list-content mt-5 lg:mt-0 lg:w-1/4 lg:pr-6">
				<div class="header flex justify-between items-center">
					<span class="font-bold text-black">{{ $t("ListNote") }}</span>
					<i
						:class="['nucleo nucleo-c-add-2 btn-add-note', {'opacity-50': isEnableNewNoteItem, 'cursor-pointer': !isEnableNewNoteItem}]"
						@click="!isEnableNewNoteItem && handleCreateNewNote()"
					></i>
				</div>

				<note-filter
					class="mt-5"
					:value="noteColors"
					:activeId="activeFilter"
					@click="handleFilterListNote"
				/>

				<div class="mt-5">
					<transition tag="div" name="slide-fade">
						<note-item
							v-if="isEnableNewNoteItem"
							:value="newNote"
							:isActive="!activeNoteItemId"
							:isRemoveable="isNewNoteRemoveable"
							@onRemove="handleRemoveNewNote"
							@click="handleClickNoteItem"
						/>
					</transition>

					<list-note-draggable
						:delay="200"
						:value="localListNote"
						:delayOnTouchOnly="true"
						:activeId="activeNoteItemId"
						@onSort="handleSortNoteItem"
						@onRemove="handleRemoveNoteItem"
						@onClickItem="handleClickNoteItem"
					/>

					<vs-button
						v-if="isHasMorePages"
						class="font-bold btn-loadmore w-full mt-5"
						@click.stop="handleLoadMoreNotes"
					>{{ $t("ViewMoreNotes") }}</vs-button>
				</div>
			</div>

			<div class="form-content lg:w-3/4 lg:pl-6 lg:border-0 lg:border-l-2 lg:border-solid">
				<note-form
					v-if="activeNoteData"
					:key="activeNoteData.id"
					v-model="activeNoteData"
					:isSubmitDisabled="!isActiveNoteDataChanged"
					@onSubmit="handleSaveActiveNoteData"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import NoteForm from "./NoteForm";
import NoteItem from "./NoteItem";
import NoteFilter from "./NoteFilter";
import moduleNote from "@/store/note/moduleNote";
import ListNoteDraggable from "./ListNoteDraggable";
import noteGQL from "@/http/requests/cbs/note_gql";

export default {
	components: {
		NoteForm,
		NoteItem,
		NoteFilter,
		ListNoteDraggable
	},
	data() {
		return {
			searchText: "",
			filterColor: "",
			currentPage: 1,
			localListNote: [],
			isAllowSearch: true,
			activeNoteData: null,
			initActiveNoteData: null,
			isEnableNewNoteItem: false
		};
	},
	computed: {
		...mapGetters({
			getParsedNotes: "notesManagement/getParsedNotes"
		}),
		notes() {
			return this.getParsedNotes || [];
		},
		newNote() {
			return {
				id: null,
				date: null,
				colorId: 1,
				color: null,
				files: null,
				content: "",
				excerpt: "",
				createdDate: null,
				updatedDate: null,
				title: this.$t("NewNote")
			};
		},
		noteColors() {
			return this.$constant.PICKER_COLORS || [];
		},
		isNewNoteRemoveable() {
			return this.localListNote && this.localListNote.length > 0;
		},
		isHasMorePages() {
			return this.$store.state.notesManagement.isHasMorePages;
		},
		activeFilter() {
			if (!this.filterColor) {
				return "all";
			}
			const activeItem = this.noteColors.find(
				item => item.value === this.filterColor
			);
			return activeItem ? activeItem.id : undefined;
		},
		activeNoteItemId() {
			return this.activeNoteData ? this.activeNoteData.id : undefined;
		},
		isActiveNoteDataChanged() {
			if (this.initActiveNoteData && this.activeNoteData) {
				return (
					JSON.stringify({
						title: this.initActiveNoteData.title,
						files: this.initActiveNoteData.files,
						content: this.initActiveNoteData.content,
						colorId: this.initActiveNoteData.colorId
					}) !==
					JSON.stringify({
						title: this.activeNoteData.title,
						files: this.activeNoteData.files,
						content: this.activeNoteData.content,
						colorId: this.activeNoteData.colorId
					})
				);
			}
			return false;
		}
	},
	watch: {
		notes() {
			this.localListNote = this.notes || [];
			if (
				!this.localListNote ||
				(this.localListNote && this.localListNote.length === 0)
			) {
				this.isEnableNewNoteItem = true;
				this.activeNoteData = this.getFormatedNewNote();
			} else {
				if (this.localListNote && this.localListNote.length > 0) {
					this.isEnableNewNoteItem = false;
					this.activeNoteData = Object.assign(
						{},
						this.localListNote.find(noteItem => noteItem.id === this.activeNoteItemId) || this.localListNote[0]
					);
				}
			}
		},
		isEnableNewNoteItem() {
			if (!this.isEnableNewNoteItem) {
				this.activeNoteData = Object.assign({}, this.localListNote[0]);
			}
		},
		isActiveNoteDataChanged() {
			if (this.isActiveNoteDataChanged) {
				this.isAllowSearch = false;
			}
		},
		activeNoteData: {
			handler: function(newVal, oldVal) {
				if (!oldVal || (newVal && newVal.id !== oldVal.id)) {
					this.initActiveNoteData = Object.assign({}, this.activeNoteData);
				}
			},
			deep: true
		}
	},
	methods: {
		async initDataNotesManangement() {
			try {
				this.$vs.loading();

				let queryOptions = {
					orderBy:{ column: "updated_at", direction: "desc" },
					page: this.currentPage,
					limit: this.$store.state.notesManagement.limitPerPage
				};

				if (this.searchText) {
					queryOptions.keyword = this.searchText.trim();
				}

				if (this.filterColor) {
					queryOptions.color = this.filterColor;
				}

				await this.$store.dispatch(
					"notesManagement/fetchNotes",
					queryOptions
				);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		handleFilterListNote(filterData) {
			if (filterData) {
				this.isAllowToLeave().then(isAllow => {
					if (isAllow) {
						const filterValue = filterData.value;
						if (
							(this.filterColor && filterData === "all") ||
							(filterData !== "all" &&
								((this.filterColor &&
									filterValue !== this.filterColor) ||
									!this.filterColor))
						) {
							this.filterColor = filterValue === "all" ? "" : filterValue;
							this.currentPage = 1;
							this.initDataNotesManangement();
						}
					}
				});
			}
		},
		handleCreateNewNote() {
			if (!this.isEnableNewNoteItem) {
				this.isAllowToLeave().then(isAllow => {
					if (isAllow) {
						this.isEnableNewNoteItem = true;
						this.activeNoteData = this.getFormatedNewNote();
					}
				});
			}
		},
		removeNoteWithConfirm(callback) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel"),
				accept: () => typeof callback === "function" && callback()
			});
		},
		async removeNoteItem(noteId) {
			try {
				this.$vs.loading();
				await this.$store.dispatch(
					"notesManagement/deleteNote",
					noteId
				);

				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("RemoveNoteSuccessful")
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		handleRemoveNoteItem(noteData) {
			this.removeNoteWithConfirm(() => this.removeNoteItem(noteData.id));
		},
		handleRemoveNewNote() {
			this.removeNoteWithConfirm(
				() => (this.isEnableNewNoteItem = false)
			);
		},
		handleClickNoteItem(noteData) {
			if (noteData.id !== this.activeNoteData.id) {
				this.isAllowToLeave().then(isAllow => {
					if (isAllow) {
						this.activeNoteData = noteData.id
							? Object.assign({}, noteData)
							: this.getFormatedNewNote();
					}
				});
			}
		},
		async handleSortNoteItem(data) {
			try {
				this.$vs.loading();
				const { oldIndex, newIndex } = data || {};
				if (data && oldIndex !== newIndex) {
					const sortedListNote = this.$helper.arrayMove(
						this.localListNote,
						oldIndex,
						newIndex
					);
					await noteGQL.sortNotes({
						ids: sortedListNote.map(note => note.id),
						keyword: this.searchText,
						color: this.filterColor
					});
					this.localListNote = sortedListNote;
				}
			} catch (error) {
				this.initDataNotesManangement();
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleLoadMoreNotes() {
			try {
				this.$vs.loading();

				this.currentPage += 1;
				const response = await noteGQL.getNotes({
					page: this.currentPage,
					limit: this.$store.state.notesManagement.limitPerPage
				});
				if (response.data) {
					this.$store.commit("notesManagement/SET_NOTES", [
						...this.localListNote,
						...response.data
					]);
					this.$store.commit(
						"notesManagement/SET_TOTAL_NOTES",
						response.total
					);
					this.$store.commit(
						"notesManagement/SET_IS_HAS_MORE_PAGES",
						response.has_more_pages
					);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
				if (this.currentPage - 1 > 0) {
					this.currentPage -= 1;
				}
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		handleFocusSearch() {
			if (!this.isAllowSearch) {
				this.$refs.inputSearchRef.$refs.vsinput.blur();
				this.isAllowToLeave().then(isAllow => {
					if (isAllow && this.$refs.inputSearchRef) {
						this.isAllowSearch = true;
						this.$refs.inputSearchRef.$refs.vsinput.focus();
					}
				});
			}
		},
		handleSearch() {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.currentPage = 1;
				this.initDataNotesManangement();
			}, 400);
		},
		getFormatedNewNote() {
			return Object.assign(
				{},
				{
					...this.newNote,
					title: null
				}
			);
		},
		async handleSaveActiveNoteData(noteData) {
			try {
				this.$vs.loading();
				const submitData = Object.assign({}, noteData);
				if(submitData && submitData.colorId) {
					const matchedColor = this.noteColors.find(item => item.id === submitData.colorId) || {};
					submitData.color = matchedColor.value;
				}
				if(submitData && submitData.files && submitData.files.length > 0) {
					submitData.files = submitData.files.map(file => file.id);
				}

				if (submitData && submitData.id) {
					await this.$store.dispatch(
						"notesManagement/updateNote",
						submitData
					);

					this.initActiveNoteData = Object.assign({}, this.activeNoteData);
				} else {
					delete submitData.id;
					await this.$store.dispatch(
						"notesManagement/addNote",
						submitData
					);
					this.isEnableNewNoteItem = false;
				}

				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t(
							`${
								noteData && noteData.id
									? "UpdateNoteSuccessful"
									: "CreateNoteSuccessful"
							}`
						)
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		isAllowToLeave() {
			return new Promise(resolve => {
				if (this.isActiveNoteDataChanged) {
					this.$vs.dialog({
						type: "confirm",
						color: "danger",
						title: this.$t("Actions.Confirm"),
						text: this.$t("LeaveConfirm"),
						acceptText: this.$t("Actions.Agree"),
						cancelText: this.$t("Actions.Cancel"),
						accept: () => resolve(true),
						cancel: () => resolve(false)
					});
				} else {
					resolve(true);
				}
			});
		}
	},
	beforeCreate() {
		this.$store.registerModule("notesManagement", moduleNote);
	},
	created() {
		this.initDataNotesManangement();
	},
	beforeDestroy() {
		this.$store.unregisterModule("notesManagement");
	}
};
</script>

<style lang="scss" scoped>
#notes-management {
	.btn-add-note::before {
		font-size: 30px;
	}

	.list-content {
		::v-deep .note-item {
			margin-bottom: 16px;

			&:last-child {
				margin-bottom: 0;
			}
		}

		.btn-loadmore {
			color: var(--color-solid-primary);
			background: #ebf2ff !important;
			border-radius: 6px;
		}
	}

	.form-content {
		border-left-color: #f4f4f4;
	}
}
</style>
